export const typeCheck = <T>(data: unknown, checker: (obj: unknown) => obj is T) => {
  if (checker(data)) {
    return data;
  } else {
    throw new Error('Invalid type');
  }
};
